import { html } from '@utilities/dom-elements';

const navigation = () => {
	const menuLink = document.querySelector('[js-hook-menulink]')
	const menuClose = document.querySelector('[js-hook-menuclose]')
	const allAosInit = document.querySelectorAll('.aos-init')
	const menuIsActive = 'menu--is-active'
	const motionIsActive = 'motion--is-active'

	menuLink.addEventListener('click', () => {
		html.classList.add(menuIsActive)

		allAosInit.forEach(item => item.classList.add('aos-animate'))

		if (html.classList.contains(motionIsActive)) html.classList.remove(motionIsActive)
	})

	menuClose.addEventListener('click', () => html.classList.remove(menuIsActive))
}

export default navigation


// WEBPACK FOOTER //
// /Users/sandersturing/Sites/SD/demo.test/frontend/source/javascript/components/navigation.js